var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback } from 'react';
import classNames from 'classnames';
import { useTranslation } from "../../../../hooks/useTranslation";
import { makeStyles, DialogContent, Grid, Typography } from "../../../../index";
import { UserSelectCard, DummyUserSelectCard } from "./UserSelectCard";
var useStyles = makeStyles(function (theme) { return ({
    root: {
        margin: theme.spacing(0, 3),
        padding: theme.spacing(2),
        backgroundColor: theme.palette.background.default,
        overflow: 'auto',
    },
    empty: {
        color: theme.palette.light.text.hint,
        alignItems: 'center',
        justifyContent: 'center',
    },
}); });
// 1行あたりのカードの枚数
// カードの幅とブレイクポイントから計算している
var MAX_CARDS_PER_ROW = 7;
var DummyUserSelectCardGrid = React.memo(function () {
    return (React.createElement(Grid, { item: true, style: { height: 0, paddingTop: 0, paddingBottom: 0 } },
        React.createElement(DummyUserSelectCard, null)));
});
var UserSelectCardGrid = React.memo(function (props) {
    return (React.createElement(Grid, { item: true },
        React.createElement(UserSelectCard, __assign({}, props))));
});
export var UserSelectDialogContent = function (props) {
    var users = props.users, onSelectUser = props.onSelectUser;
    var t = useTranslation().t;
    var classes = useStyles();
    var handleSelectUser = useCallback(function (user, selected) {
        onSelectUser === null || onSelectUser === void 0 ? void 0 : onSelectUser(user, selected);
    }, [onSelectUser]);
    if (users.length === 0) {
        // FIXME #68 ひとまず仮の文言
        return (React.createElement(DialogContent, { className: classNames(classes.root, classes.empty) },
            React.createElement(Typography, { variant: "title" }, t('選べるユーザーがいません。'))));
    }
    // ダミーのところで変数を使っていない警告が出るので抑制する
    /* eslint-disable @typescript-eslint/no-unused-vars */
    return (React.createElement(DialogContent, { className: classes.root },
        React.createElement(Grid, { container: true, spacing: 1, justify: "center" },
            users.map(function (_a) {
                var user = _a.user, selected = _a.selected, readonly = _a.readonly;
                return (React.createElement(UserSelectCardGrid, { key: user.id, user: user, selected: selected, readonly: readonly, onClick: handleSelectUser }));
            }),
            Array.from(Array(MAX_CARDS_PER_ROW - 1), function (v, k) { return (
            // 最後の行のカードを左に寄せるためのダミーカード
            React.createElement(DummyUserSelectCardGrid, { key: k })); }))));
};
